module.exports = __webpack_public_path__ + "static/media/045-slovakia.6b00a855.svg";